import { useQuery } from '@apollo/client';

import { PLACES } from '../graphql/query/placesQuery.graphql';

export const usePlacesQuery = () => {
  return useQuery(PLACES);
};
